/**
 * AI Chatbot Hooks
 *
 * Exports all React hooks for the AI Chatbot feature.
 * Phase 7: Frontend Integration
 *
 * @module ChatbotHooks
 */

// Main chatbot hook
export { useChatbot, type UseChatbotOptions } from './useChatbot';

// WebSocket hook
export { useChatSocket, type UseChatSocketOptions } from './useChatSocket';

// Spotlight hook (Phase 19E)
export { useSpotlight, type UseSpotlightReturn } from './useSpotlight';

// Field Help hook (Feature #55)
export { useFieldHelp, type FieldHelpData, type UseFieldHelpReturn } from './useFieldHelp';

// Training hook (Feature #56)
export { useTraining, type UseTrainingReturn } from './useTraining';

// SOP hook (Feature #54)
export { useSop, type UseSopReturn } from './useSop';

export {
  useVoiceRecorder,
  type UseVoiceRecorderOptions,
  type UseVoiceRecorderReturn,
} from '@/lib/voice';

// Chatbot context hook (extracted to break circular dependency)
export { useChatbotContext } from './useChatbotContext';
